import { render, staticRenderFns } from "./StoreFileList.vue?vue&type=template&id=0cab8c2d&"
import script from "./StoreFileList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StoreFileList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports